import styled from 'styled-components';

export const Wrapper = styled.div`
  flex: 1;
  position: relative;
  max-width: 720px;
  margin: 0 auto;
  pointer-events: all;

  @media (max-width: 768px) {
    display: none;
  }
`;

export const Header = styled.div`
  font-size: 12px;
  padding: 2px 8px;
  border-bottom: 1px solid #223;
  color: #223;
  background-color: #223;
  color: #fff;
  display: none;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 5px 8px;
  background-color: #060d21;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.5);
  border: 1px solid #223;
  border-radius: 10px;
`;
